export const MockProductItem = {
    brand: "Threadz",
    customAttributes: {
        total_inventory: "5",
        custom_flag: "New",
        yotpo_reviews_count: "26",
        yotpo_reviews_average: "3",
        swatch_info: [
            {
                colour_name: "Wintergold",
                product_id: "7517397811303",
                colour_hex: "#ffff00",
            },
            {
                colour_name: "Washedblue",
                product_id: "7517397614695",
                colour_hex: "#9FD7FF",
            },
            {
                colour_name: "Sage",
                product_id: "7517397581927",
                colour_hex: "#A3A58D",
            },
            {
                colour_name: "Red",
                product_id: "7517397483623",
                colour_hex: "#A52A2A",
            },
            {
                colour_name: "Purple",
                product_id: "7517397450855",
                colour_hex: "#9F6198",
            },
        ]
    },
    handle: "threadz-jogger-jean-wintergold-thre-36713",
    id: "7517397811303",
    image: {
        alt: "Jogger Jean - Wintergold",
        url: "https://birdsnest-live.myshopify.com/cdn/shop/files/THRE-36713_Wintergold_Model_nadineb_S_Full_0_20251213_S_2048x2048.jpg?v=1769466130"
    },
    media: [
        {
            alt: "Jogger Jean - Wintergold",
            url: "https://birdsnest-live.myshopify.com/cdn/shop/files/THRE-36713_Wintergold_Model_nadineb_S_Full_0_20251213_S_2048x2048.jpg?v=1769466130",
            mediaContentType: "IMAGE"
        },
        {
            alt: "Jogger Jean - Wintergold",
            url: "https://cdn.shopify.com/s/files/1/0627/4731/2231/files/THRE-36713_Wintergold_Model_nadineb_S_Crop_1_20251213_S.jpg?v=1769466131",
            mediaContentType: "IMAGE"
        },
    ],
    price: {
        regular: 54.00,
        sale: 109.95
    },
    title: "Jogger Jean - Wintergold",
    variants: [
        {
            available: false,
            id: "42136304255079",
            title: "L",
            price: {
                regular: 69.95,
                sale: 80.68
            }
        },
        {
            available: false,
            id: "42136423792743",
            title: "M",
            price: {
                regular: 69.95,
                sale: 80.68
            }
        },
        {
            available: false,
            id: "42136423825511",
            title: "S",
            price: {
                regular: 69.95,
                sale: 80.68
            }
        },
        {
            available: true,
            id: "42136423858279",
            title: "XL",
            price: {
                regular: 69.95,
                sale: 80.68
            }
        },
        {
            available: false,
            id: "42136423891047",
            title: "XXL",
            price: {
                regular: 69.95,
                sale: 80.68
            }
        },
        {
            available: false,
            id: "42136423923815",
            title: "XXXL",
            price: {
                regular: 69.95,
                sale: 80.68
            }
        }
    ]
};
export const MockProductItem2 = {
    brand: "Threadz",
    customAttributes: {
        yotpo_reviews_count: "23",
        yotpo_reviews_average: "5",
        total_inventory: "5",
        custom_flag: "New",
        swatch_info: [
            {
                colour_name: "Black",
                product_id: "7497797075047",
                colour_hex: "#333",
            },
            {
                colour_name: "Navy",
                product_id: "7497797271655",
                colour_hex: "#3895d7",
            },
            {
                colour_name: "Khaki",
                product_id: "7497797173351",
                colour_hex: "#6c6d5a",
            },
            {
                colour_name: "Beige",
                product_id: "7497797042279",
                colour_hex: "#cbd176",
            },
            {
                colour_name: "Darkdenim",
                product_id: "7497797107815",
                colour_hex: "#320fa39c",
            },
        ]
    },
    handle: "preloved-wakee-jeans-harlow-cargo-jogger-black-r-wak-cargo",
    id: "7523128344679",
    image: {
        alt: "Harlow Cargo Jogger - Black",
        url: "https://pjc4k4aliccyhyil-62747312231.shopifypreview.com/cdn/shop/files/THRE-38536_Raspberry_Model_eliseg_S_Full_0_20251228_L_2048x2048.jpg?v=1769919366"
    },
    media: [
        {
            alt: "Harlow Cargo Jogger - Black",
            url: "https://birdsnest-live.myshopify.com/cdn/shop/videos/c/vp/2f45888f594d415cb50e68984fc60186/2f45888f594d415cb50e68984fc60186.HD-1080p-7.2Mbps-65232598.mp4",
            mediaContentType: "VIDEO"
        },
        {
            alt: "JHarlow Cargo Jogger - Black",
            url: "https://birdsnest-live.myshopify.com/cdn/shop/files/THRE-36713_Wintergold_Model_nadineb_S_Full_1_20251213_S_2048x2048.jpg?v=1769466130",
            mediaContentType: "IMAGE"
        },
    ],
    price: {
        regular: 54.00,
        sale: 48.6
    },
    title: "Harlow Cargo Jogger - Black",
    variants: [
        {
            available: true,
            id: "42093472940135",
            title: "8",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472972903",
            title: "9",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42077398564967",
            title: "10",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472677991",
            title: "11",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472710759",
            title: "12",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472743527",
            title: "14",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472776295",
            title: "16",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472809063",
            title: "18",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472841831",
            title: "20",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472874599",
            title: "22",
            price: {
                regular: 64.95,
            }
        },
        {
            available: true,
            id: "42093472907367",
            title: "24",
            price: {
                regular: 64.95,
            }
        },
    ]
};
